<div class="card" ellFileDrop (filesDropped)="addFileList($event)">
    <div class="card-body">
        <input class="visually-hidden" type="file" #inputFileRef id="inputFileRef" multiple
            accept="audio/*,image/*,.docx,.doc,.odt,.csv,.xls,.xlsx,.ods" (change)="onFileChange($event)" />
        <p class="card-text" i18n>Drag and drop file here</p>
        <label class="btn btn-primary" for="inputFileRef" i18n>Choose file</label>
    </div>
</div>
